// src/components/Layout.js
import { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import FeedbackWidget from "../components/FeedbackWidget.tsx";

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDarkMode);
  }, [isDarkMode]);

return (
  <div className="relative bg-gray-100 dark:bg-gray-950">
    {/* Fixed Header */}
    <div className="fixed top-0 left-0 right-0 z-50">
      <Header
        onToggleSidebar={() => setCollapsed(!collapsed)}
        onToggleDarkMode={() => setIsDarkMode((prev) => !prev)}
        isDarkMode={isDarkMode}
      />
    </div>

    {/* Fixed Sidebar + scrollable main content */}
    <div className="flex pt-16 h-screen overflow-hidden">
      <Sidebar collapsed={collapsed} />

      <main className="flex-1 overflow-y-auto p-4">
        {children}
      </main>
    </div>
     <FeedbackWidget />

    {/* Fixed Footer (optional) */}
    {/* 
    <div className="fixed bottom-0 left-0 right-0 z-50">
      <Footer />
    </div>
    */}
  </div>
);


};

export default Layout;
